<!-- two columns only while each card is wide enough (same tb breakpoint the Plans page stacks at) -->
<div class="tw-grid tw-grid-cols-2 tw-gap-6 tb:tw-grid-cols-1">
  <!-- Hidden until the subscription has loaded (and after logout): showing it while null would
       read as Free / Ended, even for a premium user. -->
  @if (activeSubscription(); as sub) {
    <div
      [ngClass]="
        appleConfigService.iOSIAPCapability ? 'tw-col-span-2 tb:tw-col-span-1' : 'tw-col-span-1'
      "
      class="tw-flex tw-items-start tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full"
    >
      <div class="tw-flex tw-flex-col tw-w-full tw-text-base">
        <div class="tw-flex tw-flex-col tw-p-6 md:tw-p-4 tw-gap-1 border-bottom-gray">
          <div class="tw-text-sm tw-text-dt-text-secondary">{{ "plan" | i18n }}</div>
          <div class="tw-font-medium">{{ activeSubscriptionLabel() | i18n }}</div>
        </div>
        @if (sub.tier !== FREE) {
          <div class="tw-flex tw-flex-col tw-p-6 md:tw-p-4 tw-gap-1 border-bottom-gray">
            @if (sub.active) {
              <div class="tw-text-sm tw-text-dt-text-secondary">{{ "upcomingBill" | i18n }}</div>
              <div class="tw-font-medium">
                {{ sub.currency?.toUpperCase() }} {{ sub.fee }}
                <span class="tw-font-normal">{{ "on" | i18n }}</span>
                {{ sub.renewalDate | date: "yyyy-MM-dd" }}
              </div>
            } @else {
              <div class="tw-text-sm tw-text-dt-text-secondary">{{ "endDate" | i18n }}</div>
              <span class="tw-font-medium tw-text-dt-text-disabled">
                {{ sub.endDate | date: "yyyy-MM-dd" }}
              </span>
            }
          </div>
          <div class="tw-flex tw-flex-col tw-p-6 md:tw-p-4 tw-gap-1 border-bottom-gray">
            <div class="tw-text-sm tw-text-dt-text-secondary">{{ "created" | i18n }}</div>
            <span class="tw-font-medium" [ngClass]="{ 'tw-text-dt-text-disabled': !sub.active }">
              {{ sub.startDate | date: "yyyy-MM-dd" }}
            </span>
          </div>
        }
        <!-- Keep horizontal so the status badge stays inline with its label -->
        <div class="tw-flex tw-items-center tw-p-6 md:tw-p-4">
          <div class="tw-text-sm tw-text-dt-text-secondary tw-flex-1">{{ "status" | i18n }}</div>
          <div class="tw-flex">
            @if (sub.active) {
              <ng-container
                *ngTemplateOutlet="
                  statusBadge;
                  context: {
                    text: 'active',
                    className: 'tw-bg-dt-custom-teal-9/10 tw-text-dt-text-action',
                  }
                "
              ></ng-container>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  statusBadge;
                  context: {
                    text: 'ended',
                    className: 'tw-text-dt-text-headings tw-bg-dt-surface-elevated',
                  }
                "
              ></ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <ng-template #statusBadge let-text="text" let-className="className">
    <div class="tw-w-max tw-rounded-full tw-px-3 tw-py-1 {{ className }}">
      {{ text | i18n }}
    </div>
  </ng-template>

  <!--  <div class="tw-flex tw-items-center tw-flex tw-items-center-col tw-rounded-lg tw-py-4 tw-px-6">-->
  <!--    <div class="tw-text-lg tw-py-6">{{ "invoices" | i18n }}</div>-->

  <!--    @for (invoice of activeSubscription().invoices; track invoice) {-->
  <!--      <div class="tw-flex tw-items-center tw-gap-10">-->
  <!--        <div class="tw-flex tw-items-center tw-flex tw-items-center-col">-->
  <!--          <span>{{ planOptions[invoice.plan].label }}</span>-->
  <!--          <span class="tw-text-dt-text-secondary">{{ invoice.date }}</span>-->
  <!--        </div>-->
  <!--        <span>{{ invoice.amount | currency: invoice.currency }}</span>-->
  <!--      </div>-->
  <!--    }-->
  <!--  </div>-->

  <!-- the payment for ios is managed by apple, so there is no payment method card; the
       auto credit redemption toggle then stands alone (the service decides if it shows at all) -->
  @if (!appleConfigService.iOSIAPCapability) {
    <div
      class="tw-col-span-1 tw-flex tw-w-full tw-flex-col tw-gap-3 tw-rounded-3xl tw-bg-glass-card tw-pb-5 tw-pt-4 tw-px-5 sm:tw-px-4 tw-shadow-[inset_0_1px_0_0_var(--glass-rim)]"
    >
      <div class="tw-flex tw-items-center tw-px-3 tw-pb-1 tw-pt-2">
        <h2
          class="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-leading-4 tw-text-color-text-tertiary"
        >
          {{ "paymentMethod" | i18n }}
        </h2>
      </div>

      <!-- todo: this is when payment method is card, need to handle other types when stripe returns them -->
      @if (fetchingPaymentMethod()) {
        <div class="tw-px-3 tw-py-3">
          <span class="tw-animate-pulse tw-text-sm tw-text-dt-text-action">{{
            "checkingPaymentDetails" | i18n
          }}</span>
        </div>
      } @else if (paymentMethodsLoad().length) {
        @for (method of paymentMethodsLoad(); track method) {
          @if (method.type === "card") {
            <div class="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-py-3 tw-pl-2 tw-pr-3">
              <div
                class="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-bg-color-surface-elevated"
              >
                <icon
                  [name]="'payment-credit-card'"
                  [size]="5"
                  [currentColor]="'color-text-tertiary'"
                  aria-hidden="true"
                ></icon>
              </div>
              <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
                <div class="tw-flex tw-items-center tw-gap-1.5">
                  <p
                    class="tw-m-0 tw-truncate tw-text-sm tw-font-bold tw-capitalize tw-leading-5 tw-text-color-text-default"
                  >
                    {{ method.card.brand }} ···· {{ method.card.last4 }}
                  </p>
                  <span
                    class="tw-shrink-0 tw-rounded-md tw-bg-color-surface-sunken tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-leading-4 tw-text-color-text-secondary"
                  >
                    {{ "default" | i18n }}
                  </span>
                </div>
                <p
                  class="tw-m-0 tw-text-xs tw-font-medium tw-leading-4 tw-text-color-text-tertiary"
                >
                  {{ "paymentMethodExpiryDetail" | i18n: formatExpiry(method.card) }}
                </p>
              </div>
            </div>
          }
        }
      } @else {
        <div class="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-py-3 tw-pl-2 tw-pr-3">
          <div
            class="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-bg-color-surface-elevated"
          >
            <icon
              [name]="'payment-credit-card'"
              [size]="5"
              [currentColor]="'color-text-tertiary'"
              aria-hidden="true"
            ></icon>
          </div>
          <span class="tw-text-sm tw-font-bold tw-text-dt-text-warning">{{
            "detailsRequired" | i18n
          }}</span>
        </div>
      }

      <!-- wraps instead of overflowing; on small screens the buttons grow to fill each row and
           reach a 44px touch target -->
      <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-px-3 tw-pb-2">
        <button
          type="button"
          class="tw-flex tw-min-h-10 tw-max-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-[20px] tw-py-2 sm:tw-min-h-11 sm:tw-grow tw-border-0 tw-bg-color-surface-elevated tw-pl-3 tw-pr-3.5 tw-text-[13px] tw-font-medium tw-leading-[18px] tw-text-color-text-default tw-shadow-elevation-control hover:tw-shadow-elevation-card-hover"
          (click)="onAddPaymentDetails()"
        >
          <icon
            [name]="'payment-edit'"
            [size]="4"
            [currentColor]="'color-text-secondary'"
            aria-hidden="true"
          ></icon>
          @if (hasValidPaymentMethod()) {
            <span>{{ "updatePaymentDetails" | i18n }}</span>
          } @else {
            <span>{{ "addPaymentDetails" | i18n }}</span>
          }
        </button>
        @if (hasValidPaymentMethod()) {
          <button
            type="button"
            class="tw-flex tw-min-h-10 tw-max-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-[20px] tw-py-2 sm:tw-min-h-11 sm:tw-grow tw-border-0 tw-bg-transparent tw-pl-3 tw-pr-3.5 tw-text-[13px] tw-font-medium tw-leading-[18px] tw-text-color-status-error-text hover:tw-bg-color-status-error-bg"
            (click)="onDeletePaymentMethod()"
          >
            <icon
              [name]="'payment-trash'"
              [size]="4"
              [currentColor]="'color-status-error-text'"
              aria-hidden="true"
            ></icon>
            <span>{{ "removePaymentDetails" | i18n }}</span>
          </button>
        }
      </div>

      <!-- host is display:contents so it adds no empty gap when the toggle is hidden -->
      <auto-credit-redemption-toggle
        class="tw-contents"
        variant="row"
      ></auto-credit-redemption-toggle>
    </div>
  } @else {
    <!-- host is display:contents so it adds no empty grid cell / gap when the toggle is hidden -->
    <auto-credit-redemption-toggle
      class="tw-contents"
      cardClass="tw-col-span-2 tb:tw-col-span-1"
    ></auto-credit-redemption-toggle>
  }

  <!--  payment history section -->
  <div
    class="tw-col-span-2 tb:tw-col-span-1 tw-flex tw-flex-col tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full tw-overflow-hidden tw-gap-0.5"
  >
    <div class="tw-flex tw-items-center tw-py-4 tw-px-5 tw-gap-20">
      <div class="tw-font-medium">{{ "paymentHistory" | i18n }}</div>
      <!-- Development button - commented out -->
      <!-- <div>
        <button
          class="tw-border tw-border-neutral-100 tw-shadow-button tw-h-10 tw-px-3 tw-rounded-lg tw-capitalize"
          (click)="onFetchPaymentHistory()"
        >
          <span>Fetch Payment History</span>
        </button>
      </div> -->
    </div>

    @if (isFetchingAny()) {
      <div class="tw-flex tw-items-center tw-justify-center tw-py-8 tw-px-8">
        <span class="tw-animate-pulse tw-text-dt-text-action">{{
          "fetchingPaymentHistory" | i18n
        }}</span>
      </div>
    }

    @if (!isFetchingAny() && paymentHistoryCharges().length === 0) {
      <div class="tw-flex tw-items-center tw-justify-center tw-py-8 tw-px-8">
        <span class="tw-text-dt-text-tertiary">{{ "noPaymentHistory" | i18n }}</span>
      </div>
    }

    @if (!isFetchingAny() && paymentHistoryCharges().length > 0) {
      @for (charge of paymentHistoryCharges(); track charge.id) {
        <div
          class="tw-flex tw-items-center tw-py-4 tw-px-8 tw-border-0 tw-border-t tw-border-neutral-100"
        >
          <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <div class="tw-flex tw-gap-12 tw-justify-between tw-items-start">
              <div class="tw-flex tw-flex-col">
                <!-- Description -->
                <span class="tw-font-medium">
                  {{ charge.description || "Payment" }}
                </span>

                <!-- Payment method details (card brand + last4) -->
                @if (charge.payment_method_details?.card) {
                  <span class="tw-text-sm tw-text-dt-text-secondary tw-capitalize">
                    {{ charge.payment_method_details.card.brand }} ****
                    {{ charge.payment_method_details.card.last4 }}
                  </span>
                }

                <!-- TODO: Display card expiry (exp_month/exp_year) to warn about expiring cards -->
                <!-- charge.payment_method_details.card.exp_month / charge.payment_method_details.card.exp_year -->
              </div>

              <div class="tw-flex tw-flex-col tw-items-end tw-gap-1">
                <!-- Amount with currency -->
                <span class="tw-font-medium">
                  {{ charge.amount | currency: charge.currency?.toUpperCase() }}
                </span>

                <!-- Status badge with color coding -->
                @if (charge.status === "succeeded" && charge.paid) {
                  <span class="tw-text-sm tw-text-dt-text-success">{{ "paid" | i18n }}</span>
                }
                @if (charge.status === "pending") {
                  <span class="tw-text-sm tw-text-dt-text-warning">{{ "pending" | i18n }}</span>
                }
                @if (charge.status === "failed" || !charge.paid) {
                  <span class="tw-text-sm tw-text-dt-text-error">{{ "failed" | i18n }}</span>
                }
                @if (
                  charge.status !== "succeeded" &&
                  charge.status !== "pending" &&
                  charge.status !== "failed" &&
                  charge.paid
                ) {
                  <span class="tw-text-sm tw-text-dt-text-secondary tw-capitalize">{{
                    charge.status
                  }}</span>
                }

                <!-- TODO: Show if refunded -->
                <!-- @if (charge.refunded) { <span class="tw-text-sm tw-text-warning-600">Refunded</span> } -->
              </div>
            </div>

            <!-- Date and additional info -->
            <div class="tw-flex tw-gap-4 tw-text-sm tw-text-dt-text-secondary tw-items-center">
              @if (charge.created) {
                <span>{{ charge.created | date: "yyyy-MM-dd HH:mm" }}</span>
              }

              <!-- Receipt download link -->
              @if (charge.receipt_url) {
                <a
                  [href]="charge.receipt_url"
                  target="_blank"
                  class="tw-text-dt-text-action hover:tw-underline"
                >
                  {{ "downloadReceipt" | i18n }}
                </a>
              }

              <!-- TODO: Show failure message if payment failed -->
              @if (charge.failure_message) {
                <span class="tw-text-dt-text-error">{{ charge.failure_message }}</span>
              }

              <!-- TODO: Display amount refunded if partially/fully refunded -->
              <!-- @if (charge.refunded && charge.amount_refunded) { show refunded amount } -->
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
